/* eslint-disable import/prefer-default-export */
// TODO loop through other kinds, add to array
// once determined

export const determineKind = (data, property, propertiesData) => {
  const kind = { items: [] };
  propertiesData.forEach((item) => {
    if (data.data[property] !== null) {
      if (data.data[property].includes(item.label)) {
        kind.items.push(item);
      }
    }
  });
  kind.unique = (kind.items.length <= 1);
  return kind;
};

export const kindClass = (kindArr) => {
  let slugs = '';
  kindArr.forEach((item) => {
    slugs += `single-event--${item.slug} `;
  });
  return slugs;
};
